import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import DebitCreditList from "../../components/DebitCredit/List/DebitCreditList";

const DebitCreditListPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست بدهی و طلب",
            to: "/debit-credit/list",
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <DebitCreditList />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default DebitCreditListPage;
